import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

export type VendorCTAType = {
  isVendorCtaEnabled?: boolean;
  ctaVendorLink?: string;
  ctaVendorTarget?: string;
  ctaVendorButtonLabel?: string | null;
  ctaVendorAdditionalClasses?: string;
  ctaVendorCustomId?: string;
  ctaVendorSeoAttributes?: string | null;
  ctaGubagooLabel?: string | null;
  flowOptionGubagoo?: string | null;
  ctaRoadsterUrl?: string | null;
  ctaRoadsterLabelEnglish?: string | null;
  ctaRoadsterLabelFrench?: string | null;
  actionTypeRoadster?: string | null;
  pagePlacementTypeCarnow?: string | null;
  configTypeLocationUpstart?: string | null;
  configTypeLocationDarwin?: string | null;
  ctaDealerId?: string | null;
  ctaContactButtonLabel?: string | null;
  coxCtaLabel?: string | null;
};

export interface VendorCTAReducerTypes {
  vendorCtaGroup: VendorCTAType[];
}

const initialState: VendorCTAReducerTypes = {
  vendorCtaGroup: [],
};

const vendorCTAsSlice = createSlice({
  name: 'vendorCtaGroup',
  initialState,
  reducers: {
    setVendorCTAs: (_state, action: PayloadAction<VendorCTAReducerTypes>) => {
      return action.payload;
    },
  },
});

export const selectVendorCTAs = (state: RootState) => state.vendorCtaGroup;

export const { setVendorCTAs } = vendorCTAsSlice.actions;

export default vendorCTAsSlice.reducer;
